var App = App || {};

App.Base = (function ($) {
    'use strict';

    let bsElements = {};

    let modals = [];
    let modalFlag = false;

    const speedBump = $("#SpeedBump");
    let speedBumpExempt = typeof SpeedbumpData !== 'undefined' ? [...SpeedbumpData.ExemptList] : [];

    function BsElements() {

        bsElements = {
            accElements: [...$("[data-bs-toggle='collapse']")].filter(x => x.getAttribute("data-bs-target") != "").map(x => x.getAttribute("data-bs-target")),
            tabElements: [...$("[data-bs-toggle='tab']")].filter(x => x.getAttribute("id") != "").map(x => `#${x.getAttribute("id")}`),
            offcanvasElements: [...$(".offcanvas")].filter(x => x.getAttribute("id") != "").map(x => `#${x.getAttribute("id")}`)
        };

        const hash = location.hash;
        BsElementsExecute(hash);
    }

    function BsElementsExecute(candidate) {

        let bsType = false;

        for (const key in bsElements) {
            if (bsElements[key].includes(candidate)) {
                bsType = key;
            }
        }

        if (bsType == false)
            return false;

        if (bsType == "accElements") {
            const collapse = $(candidate);
            collapse.collapse("show").parents(".accordion-item").find(`[data-bs-target=\"${candidate}\"]`).trigger("focus");
            $("html, body").animate({ scrollTop: collapse.offset().top }, 200);
        }
        else if (bsType == "tabElements") {
            const tab = $(candidate);
            tab.tab("show").trigger("focus");
            $("html, body").animate({ scrollTop: tab.offset().top }, 200);
        }
        else if (bsType == "offcanvasElements") {
            const offcanvas = $(candidate);
            offcanvas.offcanvas("show");
        }

        return true;
    }

    function Modals() {

        $.ajax({
            type: "GET",
            url: "/Api/Modals/GetModalUrls",
            success: function (result) {
                modals = [...result];
                const href = location.hash.replace("#", "/").toLowerCase();
                ModalsExecute(href, null);
            }
        })
    }

    function ModalsExecute(href, clicked) {

        if (href !== "" && modals.includes(href))
            href = href;
        else
            return false;

        $.ajax({
            type: "GET",
            url: href,
            success: function (result) {

                const modalData = {
                    "id": $(result).filter(".modal").attr("id"),
                    "content": $(result).filter(".modal").prop("outerHTML")
                };

                $("body").append(modalData.content);
                const modal = $(`#${modalData.id}`);

                App.Base.ClickSupport(modal.find("a"));
                modal.modal("show").on("hidden.bs.modal", function () {
                    if (clicked !== null) {
                        clicked.trigger("focus").trigger("blur");
                    }
                    if (!modalFlag) {
                        $(this).remove();
                    }
                });

            }
        });

        return true;
    }

    function SpeedBumpExecute(clicked) {

        const hostname = clicked[0].hostname;
        const href = clicked.attr("href");

        if (hostname === location.hostname || $.inArray(hostname, speedBumpExempt) !== -1 || !href || IsUriSchema(href)) {
            return false;
        }

        // check to see if speedbump was triggered from a modal
        const modalParent = clicked.parents(".modal").first();
        modalFlag = modalParent.length != 0;
        modalParent.modal("hide");

        speedBump.modal("show");
        speedBump.find("button[data-speedbump='proceed']")
            .off("click")
            .on("click", function () {
                speedBump.modal("hide");
                window.open(href);
            }
        );

        speedBump.on("hidden.bs.modal", function () {
            clicked.trigger("focus").trigger("blur");
            if (modalFlag) {
                modalParent.modal("show");
                modalFlag = false;
            }
        });

        return true;

    }

    function ClickSupport(selector) {

        selector.on("click", function (e) {

            const href = $(this).attr("href");

            if (BsElementsExecute(href) == true)
                return false;

            if (ModalsExecute(href, $(this)) == true) {
                e.preventDefault();
                return false;
            }

            if (SpeedBumpExecute($(this)) == true) {
                e.preventDefault();
                return false;
            }
        });
    }

    function IsUriSchema(href) {

        const uriSchemes = ["javascript:", "mailto:", "tel:"];

        for (var i in uriSchemes) {
            if (href.indexOf(uriSchemes[i]) > -1) {
                return true;
            }
        }
        return false;
    }

    function RichTextResponsiveTables(selector) {
        selector.each(function () {
            if (!$(this).parent().hasClass("table-responsive")) {
                $(this).wrap("<div class=\"table-responsive\"></div>")
            }
        });
    }

    // https://davidwalsh.name/query-string-javascript
    function GetUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    function SwipeInit($widget) {
        const speed = 250;
        const $controls = $widget.find('.swipe-tabs__swipe-controls button');
        const $mask = $widget.find('.swipe-tabs__swipe-mask');
        const $scroll = $widget.find('.swipe-tabs__swipe-scroll');
        const $content = $widget.find('.swipe-tabs__swipe-content');
        const $focus = $widget.find('.swipe-tabs__swipe-content *');

        if ($content.width() > $scroll.width()) {
            $widget.addClass('mask-fwd');
        }

        // help if content element is focused on while outside of view
        $focus.on('focus', function () {
            var activeOffset = $(this).position().left + $content.position().left;

            if (activeOffset + $(this).outerWidth() > $mask.width()) {
                $scroll.stop().animate({
                    scrollLeft: $(this).offset().left + $(this).outerWidth() - $mask.width() + $scroll.scrollLeft() + 36
                }, speed * 2);
            }

            if (activeOffset < 0) {
                $scroll.stop().animate({
                    scrollLeft: activeOffset + $scroll.scrollLeft() - 78
                }, speed * 2);
            }
        });

        $controls.on('click', function () {

            const distance = (() => {
                switch ($(this).attr('data-swipe')) {
                    case 'fwd':
                        return $scroll.scrollLeft() + $scroll.width() - 100;
                    case 'back':
                        return $scroll.scrollLeft() - $scroll.width();
                    default:
                        return 0;
                }
            })();

            $scroll.stop().animate({
                scrollLeft: distance
            }, speed * 2);
        });

        $scroll.on('scroll', function () {
            AdjustSwipeControls($widget, $scroll, $content, $controls, speed);
        });

        $(window).on('resize', function () {
            AdjustSwipeControls($widget, $scroll, $content, $controls, speed);
        });
    }

    function AdjustSwipeControls($tabbedContentBand, $scroll, $content, $controls, speed) {

        if ($scroll.scrollLeft() <= 10) {
            $tabbedContentBand.removeClass('mask-back');
        }
        else {
            $tabbedContentBand.addClass('mask-back');
        }

        if ($scroll.scrollLeft() >= $content.width() - $scroll.width() - 10) {
            $tabbedContentBand.removeClass('mask-fwd');
        }
        else {
            $tabbedContentBand.addClass('mask-fwd');
        }
    }

    return {
        BsElements: BsElements,
        Modals: Modals,
        ClickSupport: ClickSupport,
        RichTextResponsiveTables: RichTextResponsiveTables,
        GetUrlParameter: GetUrlParameter,
        SwipeInit: SwipeInit
    };

})(jQuery);

$(function () {
    App.Base.BsElements();
    App.Base.Modals();
    App.Base.ClickSupport($("a"));
    App.Base.RichTextResponsiveTables($(".rich-text table.table"));
});